import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { TimelineItem } from "@customTypes/timeline";

import { timelineQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data.data);
  const years =
    res.data.meta.years?.map((year: number) => year.toString()) || [];

  if (res.data.data.length) {
    const newData: TimelineItem[] = [];

    for (const i in res.data.data) {
      const { date, day, data } = res.data.data[i];
      newData.push({
        date: new Date(date),
        day: day?.toLocaleLowerCase(),
        data: data
          .map((item: any) => ({
            ...item,
            doctor: {
              id: item.doctor?._id,
              fullName: item.doctor?.full_name,
            },
            date: new Date(item.date),
            recordType:
              item.record_type === "preventative"
                ? "immunization"
                : item.record_type,
          }))
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          .map(({ record_type, ...rest }: any) => ({ ...rest }))
          .sort((a: any, b: any) => b.date.getTime() - a.date.getTime()),
      });
    }

    newData.sort((a, b) => b.date.getTime() - a.date.getTime());
    // console.log(newData);
    return { newData, years };
  }
  return null;
};

interface QueryProps {
  patientId: string;
}

export const useGetTimelineForPatient = ({ patientId }: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: timelineQKeys.patient(patientId),
    queryFn: () => api.get(`timeline/`, { params: { patient_id: patientId } }),
    select,

    onError: res => {
      console.error("[From Get Timeline for Patient]", res);
      handleErrors(res, "query");
    },
  });
};
